import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "bg-slate-50"
}

import AccessibilityControls from "./components/Reusables/AccessibilityControls.vue";
import UniqueForm from "./components/Reusables/UniqueForm.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UniqueForm),
    _createVNode(_component_router_view),
    _createVNode(AccessibilityControls)
  ]))
}
}

})